export const environment = {
  // every app talks to the same host in this environment
  baseUrl: 'https://dev.api.salonfriday.com',
  fiservTerminalUrl: 'https://bolt-uat.cardpointe.com/api/v3',
  refreshTokenExpMinutes: 117,
  // CardConnect (Fiserv) hosted iToke tokenizer — UAT/sandbox.
  fiserv: {
    hostedIframeTokenizeUrl: 'https://isv-uat.cardconnect.com/itoke/ajax-tokenizer.html',
    allowedTokenizerOrigins: ['https://isv-uat.cardconnect.com'],
  },
};
